export default [{
  path: '/analyse/index',
  name: 'analyse-index',
  title: '顾客分析',
  component: () => import('@/views/analyse/index')
}];
